import {
	ChangeDetectionStrategy,
	Component
} from '@angular/core';

@Component({
	selector: 'auth-template',
	templateUrl: './auth-template.component.html',
	styleUrls: ['./auth-template.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class AuthTemplateComponent {

	constructor () {}

}
